<template lang="pug">
svg.block
  line(x1="0", y1="0", x2="100%", y2="100%", stroke="currentColor")
  line(x1="0", y1="100%", x2="100%", y2="0%", stroke="currentColor")
</template>

<script>
export default {
  name: 'SVG-X'
}
</script>
